// 模擬裝置 GPS：demo 環境的瀏覽器定位常被封鎖或不精準，
// 這裡固定回傳「東京車站附近」加上小幅隨機飄移，模擬每次快速記錄時位置有些微不同，
// 並清楚標示「模擬」給使用者知道這不是真的 GPS。
export function getMockLocation (label) {
  return {
    lat: 35.681236 + (Math.random() - 0.5) * 0.02,
    lng: 139.767125 + (Math.random() - 0.5) * 0.02,
    label: label || '目前位置（模擬定位）'
  }
}
